import { render } from "./StoryList.vue?vue&type=template&id=2fcd1b99&ts=true"
import script from "./StoryList.vue?vue&type=script&lang=ts"
export * from "./StoryList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__